import { createContext, useContext } from 'react';

export interface CampaignContextInterface {
    slug: string;
}

export const defaultContext: CampaignContextInterface = {
    slug: '',
};

export const CampaignContext = createContext(defaultContext);

export const useCampaign = () => useContext(CampaignContext);
